import { atom } from 'jotai';
import { BrandDeal } from "@quantizr-engineering/common/types/brand-deal";


export interface BrandDealState {
    loading: boolean;
    data: BrandDeal[] | null;
    lastFetched: number | null;
  }

export const brandDealAtom = atom<BrandDealState>({
  loading: false,
  data: [],
  lastFetched: null,
});
